import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import RiskLevelSticker from 'dashboard/components/RiskLevelSticker';
import { SelfieIdComparison } from 'dashboard/models/check';

export const computeSelfieIdComparisonMetadata = (check: SelfieIdComparison): CheckMetadata => {
  const metadata = check.metadata;
  const risks = metadata ? metadata['risks'] : null;
  const faceComparisonRiskData = risks?.find((r) => r.reason === 'face_mismatch');

  if (faceComparisonRiskData && faceComparisonRiskData['level']) {
    return {
      metadata: createSimpleCheckMetadataArray([
        {
          label: 'Face Comparison Risk',
          value: RiskLevelSticker({ riskLevel: faceComparisonRiskData['level'] }),
        },
      ]),
      hideIfVerificationPassed: false,
    };
  }

  return {
    metadata: [],
    hideIfVerificationPassed: false,
  };
};
